/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './ErrorOrNotFoundPage.scss';

import { useRouteError } from 'react-router';
import { ContentBlock, NotFoundPage, Heading, Text, Icon } from 'sarsaparilla';

interface RouterError extends Error {
    status: number;
}

function isRouterError(object: any): object is RouterError {
    return 'status' in object;
}

interface ErrorOrNotFoundPageProps {
    /**
     * Give the error state its own `main` landmark. Set this when the
     * surrounding layout does not wrap the outlet in one.
     */
    wrapInMain?: boolean;
}

export function ErrorOrNotFoundPage({ wrapInMain = false }: ErrorOrNotFoundPageProps) {
    const error = useRouteError();
    // eslint-disable-next-line no-console
    console.error(error);

    if (isRouterError(error) && error.status === 404) {
        return <NotFoundPage />;
    }

    return (
        <ContentBlock
            role={wrapInMain ? 'main' : undefined}
            className="shared-error-or-not-found-page"
        >
            <Icon iconName="warning" size="xl" />
            <Heading
                headingLevel={1}
                appearance="h4"
                headingAlign="center"
                className="my-1"
            >
                Something Went Wrong
            </Heading>
            <Text size="xl" align="center">
                Sorry, an unexpected error occurred. Refresh the page and try again.
            </Text>
        </ContentBlock>
    );
}
